import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/Icons/search.svg";
import { ReactComponent as CloseIcon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as MenuIcon } from "../../assets/Icons/MenuIcon.svg";
import { ReactComponent as DownArrow } from "../../assets/Icons/filledArrow.svg";
import { ReactComponent as CircleArrow } from "../../assets/Icons/filledCircleArrow.svg";
import { ReactComponent as SignOutIcon } from "../../assets/Icons/signOut.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import {
  appInfo,
  authenticate,
  getUserSubscription,
  getLanguageList,
  updateUserLanguage,
} from "../../network/service";
import { useTranslation } from "react-i18next";
import { setRTL } from "../../Redux/RTL/RTLSlice";
import * as service from "./service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import SmallLoading from "../Loading/SmallLoading";
import DetailScreenModal from "../../Screens/ShowDetailsScreen/DetailScreenModal";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import { imageUrlCheck } from "../../utils/utils";
import Translate from "../MultiLanguage/Translate"
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { getPodcastModal } from "../../Redux/PodcastModal/podcastModalSlice";
import { getEventMoreInfo } from "../../Redux/MoreInfo/eventMoreInfoSlice";
import { getLanguageModal } from "../../Redux/LanguageModal/languageModalSlice";
import { getUserDetails } from "../../Redux/UserDetailsSlice/UserDetailsSlice";
import { useTranslateText } from "../MultiLanguage/Translate";
const Header = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const isModalOpen = useSelector((state) => state?.moreInfoOther?.value);
  const selectedLanguageCode = useSelector((state) => state?.languageModal?.value?.selectedLanguageCode);

  const [inputValue, setInputValue] = useState("");
  const [searchResults, setSearchResults] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [menuItems, setMenuItems] = useState();
  const [mainMenuItems, setMainMenuItems] = useState([]);
  const [hoveredMenuIndex, setHoveredMenuIndex] = useState(null);
  const [browseHover, setBrowseHover] = useState(false);
  const [browseMoreMediumDevice, setBrowseMoreMediumDevice] = useState(false);
  const [position, setPosition] = useState(window.pageYOffset);
  const [headerVisible, setHeaderVisible] = useState(true);
  const [userInfo, setUserInfo] = useState(false);
  const [previousLocation, setPreviousLocation] = useState("");
  const [menuHandler, setMenuHandler] = useState(false);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [IsSearchLoading, setIsSearchLoading] = useState(false);
  const [subscriptionLink, setSubscriptionLink] = useState(true)
  const [languageOptions, setLanguageOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({ short_code: 'en' });
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [isSubscribedUser, setIsSubscribedUser] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const menuRef = useRef(null);
  const searchRefContainer = useRef(null);
  const searchRefSmall = useRef(null);
  const searchRefSmallContainer = useRef(null);
  const searchSuggestionRef = useRef(null);
  const { i18n } = useTranslation();
  const browseMoreContainerRef = useRef(null);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const translateText = useTranslateText();
  const handleLanguageClick = (e) => {
    e.stopPropagation();
    setIsLanguageOpen(!isLanguageOpen);
    
    setTimeout(() => {
      if (browseMoreContainerRef.current) {
        browseMoreContainerRef.current.scrollTo({
          top: browseMoreContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  useEffect(() => {
    const fetchLanguageOptions = async () => {
      try {
        const response = await getLanguageList(appInfo);
        const data = response?.data?.data;
        setLanguageOptions(data);

        // const savedLanguageId = localStorage.getItem("selectedLanguageId");
        // const savedLanguageCode = localStorage.getItem("selectedLanguageCode");

        // let selectedLang = data.find(
        //   (option) => 
        //     option?.language_id === parseInt(savedLanguageId) ||
        //     option?.short_code === savedLanguageCode
        // );

        // if (!selectedLang && userDetails?.short_code) {
        //   selectedLang = data.find(
        //     (option) => option?.short_code === userDetails?.short_code
        //   );
        // }

        // if (!selectedLang) {
        //   selectedLang = data.find(option => option?.short_code === 'en') || data[0];
        // }

        let selectedLang;
      
        if (user && userDetails?.language_id) {
          selectedLang = data.find(
            option => option?.language_id === parseInt(userDetails?.language_id) || option?.short_code === userDetails?.short_code
          );
        }
        
        if (!selectedLang) {
          const savedLanguageId = localStorage.getItem("selectedLanguageId");
          const savedLanguageCode = localStorage.getItem("selectedLanguageCode");
          
          selectedLang = data.find(
            option => 
              option?.language_id === parseInt(savedLanguageId) ||
              option?.short_code === savedLanguageCode
          );
        }
  
        if (!selectedLang) {
          selectedLang = data.find(option => option?.short_code === 'en') || data[0];
        }
  
        setSelectedLanguage(selectedLang);
        
        if (selectedLang?.short_code) {
          i18n.changeLanguage(selectedLang.short_code);
          if (!i18n.hasResourceBundle(selectedLang.short_code, 'translation')) {
            i18n.addResourceBundle(
              selectedLang.short_code,
              'translation',
              projectInfo?.projectConfig?.config?.LANGUAGE_KEYWORDS,
              true,
              true
            );
          }
        }
      } catch (error) {
        console.error("Failed to fetch language options:", error);
      }
    };
  
    fetchLanguageOptions();
  }, [userDetails, user]);

  useEffect(() => {
    dispatch(setRTL(selectedLanguage));
  }, [selectedLanguage, dispatch]);

  const handleLanguageChange = async (language) => {
    try {
      setSelectedLanguage(language);
      setIsLanguageOpen(false);
  
      const response = await updateUserLanguage(appInfo, language?.language_id);
      
      if (response?.status === 200) {
        const authResponse = await authenticate(appInfo);
        
        localStorage.setItem('selectedLanguageCode', language?.short_code);
        localStorage.setItem('selectedLanguageId', language?.language_id.toString());
        localStorage.setItem('selectedLanguageName', language?.language_name);
  
        const hasResources = i18n.hasResourceBundle(language?.short_code, 'translation');
      
        if (!hasResources) {
          try {
            i18n.addResourceBundle(
              language?.short_code,
              'translation',
              projectInfo?.projectConfig?.config?.LANGUAGE_KEYWORDS,
              true,
              false  
            );
          } catch (error) {
            console.warn('Resource bundle already exists:', error);
          }
        }

        await i18n.changeLanguage(language?.short_code);
  
        dispatch(
          getLanguageModal({
            languageModal: {
              selectedLanguageCode: language?.short_code
            }
          })
        );
  
        dispatch(
          getUserDetails({
            userDetails: {
              ...userDetails,
              language_id: language?.language_id,
              short_code: language?.short_code
            }
          })
        );

        dispatch(setRTL(language));
  
        toast.success(response?.data?.message, {
          position: "top-center"
        });
      }
    } catch (error) {
      console.error("Failed to update language:", error);
      toast.error(<Translate textKey={'failed_to_update_language'}/>, {
        position: "top-center"
      });
      
      const savedLang = languageOptions.find(
        opt => opt.language_id === parseInt(localStorage.getItem("selectedLanguageId"))
      );
      if (savedLang) {
        setSelectedLanguage(savedLang);
        i18n.changeLanguage(savedLang?.short_code).catch(console.error);
      }
    }
    window.location.reload();
  };

  useEffect(() => {
    const handleScroll = () => {
      let moving = window.pageYOffset;
      // setHeaderVisible(position > moving);
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (searchActive) {
      // searchRef?.current.focus();
      setTimeout(() => {
        searchRef?.current?.focus();
        searchRefSmall?.current?.focus();
      }, 100);
      searchRefSmallContainer?.current?.focus();
      setPreviousLocation(location);
    }
  }, [searchActive]);

  useEffect(() => {
    if (accessToken) {
      fetchUserSubscriptionDetails(appInfo, setIsSubscribedUser);
    }
  }, [user, accessToken]);

  useEffect(() => {
    fetchMenuItems();
  }, []);

  useEffect(() => {
    let handleOutClick = (e) => {
      if (
        !searchRefContainer?.current?.contains(e.target) &&
        !searchRefSmallContainer?.current?.contains(e.target)
      ) {
        setInputValue("");
        setSearchActive(false); //outside click
      }

      if (!searchSuggestionRef?.current?.contains(e.target)) {
        setInputValue("");
        // setSearchActive(false)
        setSearchResults(null);
      }

      // if (!menuRef?.current?.contains(e.target)) {
      //   setMenuHandler(false); //outside click
      // }
    };

    window.addEventListener("click", handleOutClick);
    return () => {
      window.addEventListener("click", handleOutClick);
    };
  }, [
    searchRefContainer,
    searchRefSmallContainer,
    menuRef,
    searchSuggestionRef,
  ]);

  useEffect(() => {
    if (inputValue) {
      setIsSearchLoading(true);
      fetchSearchData();
    } else {
      setIsSearchLoading(false);
      setSearchResults(null);
    }
  }, [inputValue]);
  // useEffect(() => {
  //   searchResultsShow();
  // }, [searchResults]);
  const fetchMenuItems = async () => {
    try {
      const menuResponse = await service.getMenuItems(appInfo);
      if (menuResponse?.status === 200) {
        setMenuItems(menuResponse?.data?.data);
        setMainMenuItems(menuResponse?.data?.menu);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-center",
      });
    }
  };

  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {

      const currentUserSubscription = userSubResponse?.data?.data.filter(
        (item) => item.subscription_type_id === 3 || item.subscription_type_id === 4
      );

      if (currentUserSubscription?.length > 0) {
        setSubscriptionLink(false)
      }

      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };

  /// Search functionality  start
  const searchSubmit = (value) => {
    if (value) {
      setInputValue("");
      setSearchActive(false);
      if (searchResults?.length > 0) {
        navigate(`/search?query=${value}`, { state: { searchResults } });
      } else {
        navigate(`/search?query=${value}`);
      }
    } else {
      navigate(previousLocation?.pathname, { state: previousLocation?.state });
      setInputValue("");
    }
  };
  const searchSubmitBrowseMore = (value) => {
    setSearchActive(true);
    if (value) {
      setInputValue("");
      if (searchResults?.length > 0) {
        navigate(`/search?query=${value}`, { state: { searchResults } });
      } else {
        navigate(`/search?query=${value}`);
      }
      setBrowseMoreMediumDevice(null);
    } else {
      navigate(previousLocation?.pathname, { state: previousLocation?.state });
      setInputValue("");
    }
    // if (!searchActive) {
    //   setSearchActive(true);
    // } else {
    //   setSearchActive(false);
    //   setBrowseMoreMediumDevice(null);
    // }
  };

  /// end

  const logoutHandler = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedSubId");
    localStorage.removeItem("deviceType");
    localStorage.removeItem("redirectPath");
    localStorage.removeItem("ageVerified");
    tokenAuthenticate();
  };

  const tokenAuthenticate = async () => {
    const response = await authenticate(appInfo);
    if (response?.status === 200) {
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
      navigate("/home");
      setTimeout(() => {
        dispatch(
          getUser({
            user: null,
          })
        );
      }, 300);
    }
  };

  const fetchSearchData = async () => {
    try {
      const response = await service?.getSearchData(appInfo, inputValue);
      if (response?.status === 200) {
        setSearchResults(response?.data?.data);
        setIsSearchLoading(false)
      } else {
      }
    } catch (err) {
      setIsSearchLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  const showClickHandler = (data, medium) => {
    if (medium) {
      setBrowseMoreMediumDevice(false);
    }
    if (data?.type === "LIVE_EVENT") {
      navigate(`/event/${data?.show_id}`, { state: { data } })
      dispatch(
        getEventMoreInfo({
          eventMoreInfo: {
            isModal: true,
            eventId: data?.vanity_url ? data?.vanity_url : data?.event_id
          }
        })
      )
    } else if (data?.type === "PODCAST") {
      let podcastData = {
        isOpen: true,
        data
      }
      dispatch(
        getPodcastModal({
          podcastModal: podcastData
        })
      )
    } else if (data?.type === "NEWS") {
      navigate(`/news-info/${data?.show_id}`)
    }
    else if (data?.type === "CONTINUE_WATCHING") {
      navigate(`/show-details/${data?.vanity_url ? data?.vanity_url : data?.show_id}`, {
        state: { showId: data?.show_id, type: data?.type },
      })
    }
    else if (data?.type === "UPCOMING_EVENT") {
      dispatch(
        getEventMoreInfo({
          eventMoreInfo: {
            isModal: true,
            eventId: data?.vanity_url ? data?.vanity_url : data?.event_id
          }
        })
      )
      navigate(`/event/${data?.show_id}`, { state: { data } })

    }
    else if (data?.type === "VIDEO") {
      navigate(`/videos/${data?.vanity_url ? data?.vanity_url : data?.show_id}`, {
        state: { videoDetails: data, showId: data?.show_id, prevPath: location?.pathname },
      })
    }
    else if (data?.type === "SHOW") {
      navigate(`/show-details/${data?.vanity_url ? data?.vanity_url : data?.show_id}`, {
        state: { showId: data?.show_id, type: data?.type },
      })
    }
    else if (data?.type === "FASTCHANNEL") {
      navigate(`/live-channels`, {
      })
    }
    else if (data?.type === "EVENT") {
      navigate(`/event/${data?.vanity_url ? data?.vanity_url : data?.event_id}`)
    }
    else if (data?.type === "PODCASTS") {
      let podcastData = {
        isOpen: true,
        data
      }
      dispatch(
        getPodcastModal({
          podcastModal: podcastData
        })
      )
    }
    else {
      navigate(`/show-details/${data?.vanity_url}`, {
        state: { showId: data?.show_id, type: data?.type },
      })
      dispatch(
        getMoreInfo({
          moreInfo: true
        })
      )
      dispatch(
        getMoreInfoOther({
          moreInfoOther: {
            isModal: true,
            showId: data?.vanity_url ? data?.vanity_url : data?.show_id,
            isFromSearch: true
          }
        })
      )
      setSearchResults(null);
    }
  };

  const searchClose = () => {
    setSearchActive(false);
    setInputValue("");
    setSearchResults(null);
  };

  const handleClick = (index) => {
    if (hoveredMenuIndex === index) {
      setHoveredMenuIndex(null);
    } else {
      setHoveredMenuIndex(index);
    }
  };

  const renderMenuItems = (items) => {
    return items?.map((item, index) => {
      if (item?.type === "MENU") {
        return (
          <li
            key={index}
            className={hoveredMenuIndex === index ? "link active" : "link no-active"}
            onClick={() =>{ handleClick(index); setBrowseMoreMediumDevice(false); }}
          >
            { hoveredMenuIndex === index && <div className="overlay" />}
            <span className="menu">{item?.value}</span>
            {hoveredMenuIndex === index && item?.items?.length > 0 && (
              <div className="browseMoreContainer">
                <div className="arrow">
                  <DownArrow />
                </div>
                <div className={`left ${item?.items?.some((subItem) => subItem?.type === "LINK") ? "block" : ""}`}>
                  {item?.items?.map((subItem, subIndex) => {
                    if (subItem?.type === "MENU") {
                      return (
                        <div key={subIndex}>
                          <h1 className="categoryName">{subItem?.value}</h1>
                          <ul>{renderMenuItems(subItem?.items)}</ul>
                        </div>
                      );
                    } else if (subItem?.type === "LINK") {
                      return (
                        <div key={subIndex}>
                        <ul>
                          <li
                            onClick={() => {
                              setBrowseMoreMediumDevice(false)
                              if (subItem?.seo_url) {
                                if(subItem.seo_url === "live") {
                                  const state = { isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname };
                                  localStorage.setItem("liveState", JSON.stringify(state));
                                  navigate(subItem?.seo_url, { state })
                                }
                                if (subItem.seo_url.startsWith('category/')) {
                                  const val = subItem.seo_url.substring(subItem.seo_url.lastIndexOf('/') + 1);
                                  navigate(`/${subItem.seo_url}?career=${val}`, {
                                    state: { careers: val },
                                  });
                                } else {
                                  navigate(`/${subItem.seo_url}`);
                                }
                              } else if (subItem?.link) {
                                window.open(subItem?.link, "_blank");
                              }
                            }}
                          >
                            <span>{subItem?.value}</span>
                          </li>
                        </ul>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            )}
          </li>
        );
      } else if (item?.type === "LINK") {
        return (
          <li
            key={index}
            onClick={() => {
              setBrowseMoreMediumDevice(false)
              if (item?.seo_url) {
                if(item.seo_url === "live") {
                  const state = { isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname };
                  localStorage.setItem("liveState", JSON.stringify(state));
                  navigate(`${item.seo_url}`, { state })
                }
                if (item.seo_url.startsWith('category/')) {
                  const val = item.seo_url.substring(item.seo_url.lastIndexOf('/') + 1);
                  navigate(`/${item.seo_url}?career=${val}`, {
                    state: { careers: val },
                  });
                } else {
                  navigate(`/${item.seo_url}`);
                }
              } else if (item?.link) {
                window.open(item?.link, "_blank");
              }
            }}
            className="link"
          >
            <span className="menu">{item?.value}</span>
          </li>
        );
      }
      return null;
    });
  };
  
  return (
    <>
      {
        isModalOpen?.isModal && isModalOpen?.isFromSearch &&
        <DetailScreenModal />
      }
      <ToastContainer />
      <div
        className={browseMoreMediumDevice ? "active overlayOne" : "overlayOne"}
        onClick={() => setBrowseMoreMediumDevice(false)}
      ></div>
      <div
        className={
          position === 0 ? "header-container" : "header-container background"
        }
      >
        <div className="wrapper">
          <div className="menuIconContainer">
            <MenuIcon
              ref={menuRef}
              onClick={() => setBrowseMoreMediumDevice(true)}
            />
          </div>
          <div className="leftContainer">
            <div className="logoContainer">
              <Link to="/home">
                <h1>
                  <img
                    src={projectInfo?.projectConfig?.config?.LOGO}
                    alt="Logo"
                  />
                </h1>
              </Link>
            </div>

            <nav>
              <ul className="navLinks">
                { mainMenuItems?.length === 0 && (
                  <>
                    <Link to="/home">
                      <li className="link"><Translate textKey={'home'} /></li>
                    </Link>
                    {projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" ? (<Link to="/live-channels" >
                      <li className="link"><Translate textKey={'live'} /></li>
                    </Link>) : (projectInfo?.projectConfig?.config?.LIVE_REQUIRED === "true" && <Link to="/player" state={{ isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname }}>
                      <li className="link"><Translate textKey={'live'} /></li>
                    </Link>)}
                    {projectInfo?.projectConfig?.config?.SHORTS_REQUIRED === "true" && user && <Link to="/shorts">
                    <li
                      className="link"
                    >
                      <Translate textKey={'shorts'} />
                    </li>
                    </Link>
                    }
                    {
                      user &&
                      <Link to="/my-list">
                        <li className="link"><Translate textKey={'my_list'} /></li>
                      </Link>
                    }
                  </>
                )}
                {/* {
                  user &&
                  <Link to="/my-list">
                    <li className="link"><Translate textKey={'my_list'} /></li>
                  </Link>
                } */}
              { mainMenuItems?.length !==0 ? (
                  renderMenuItems(mainMenuItems)
                ) : (
                  <>
                    <li
                      className={browseHover ? " link active" : "link no-active"}
                      onClick={() => {
                        setBrowseHover(!browseHover);
                        setBrowseMoreMediumDevice(true);
                        setMenuHandler(false);
                      }}
                    >
                      <Translate textKey={'browse'} />
                    </li>
                  </>
                )
              }
                {subscriptionLink && projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && <Link to="/checkout">
                  <li className="link">{<Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT || 'subscribe'}/>}</li>
                </Link>}
              </ul>
            </nav>
          </div>
          <div className="rightContainer">
            <div
              className={
                searchActive ? "inputContainer showInput" : "inputContainer"
              }
              ref={searchRefContainer}
              onClick={() => {
                setSearchActive(true);
                setTimeout(() => {
                  searchRef?.current.focus();
                }, 0);
              }}
            >
              {searchActive ? (
                <SearchIcon
                  onClick={
                    () => {
                      searchSubmit(inputValue);
                      searchRef?.current.focus();
                    }
                    // setSearchActive(!searchActive)
                  }
                />
              ) : (
                <SearchIcon
                  onClick={() => {
                    setSearchActive(true);
                    setTimeout(() => {
                      searchRef?.current.focus();
                    }, 0);
                  }}
                />
              )}

              <input
                ref={searchRef}
                onClick={() => setSearchActive(true)}
                type="text"
                value={inputValue || ""}
                // placeholder={searchActive && "Find Movies, TV shows and more"}
                placeholder={translateText('search') }
                onChange={(e) => {
                  // searchHandleChange(e?.target?.value);
                  setInputValue(e?.target?.value);
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? searchSubmit(inputValue) : ""
                }
              />
              {IsSearchLoading && (
                <div className="searchLoading">
                  <SmallLoading />
                </div>
              )}

              {!IsSearchLoading && searchResults?.length > 0 && inputValue && (
                <div className="closeIcon">
                  <CloseIcon onClick={() => searchClose()} />
                </div>
              )}
              {searchResults?.length > 0 && inputValue && (
                <div className="searchSuggestionsContainer" ref={searchSuggestionRef}>
                  <ul className="lists">
                    {searchResults?.slice(0, 8)?.map((item, index) => (
                      <div key={index} className="categorySection">
                        <h6 className="heading">
                          {item?.category_name}
                        </h6>
                        {item?.shows?.map((show, showIndex) => (
                          <li
                            className="list"
                            key={`${index}-${showIndex}`}
                            onClick={() => showClickHandler(show)}
                          >
                            <div className="listContainer">

                              <div className="left">
                                <div className="imageContainer">
                                  {imageUrlCheck(
                                    thumbnailOrientation === "PORTRAIT"
                                      ? show?.logo
                                      : show?.logo_thumb
                                  ) ? (
                                    <img
                                      src={
                                        thumbnailOrientation === "PORTRAIT"
                                          ? `${show?.logo}`
                                          : `${show?.logo_thumb}`
                                      }
                                      alt="Thumb"
                                    />
                                  ) : (
                                    <img
                                      src={
                                        thumbnailOrientation === "PORTRAIT"
                                          ? `${process.env.REACT_APP_IMAGE_URL}${show?.logo}`
                                          : `${process.env.REACT_APP_IMAGE_URL}${show?.logo_thumb}`
                                      }
                                      alt="Thumb"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="right">
                                <h1 className="title">
                                  {show?.show_name?.slice(0, 50)}
                                  {show?.show_name?.length > 50 && "..."}
                                </h1>
                                <span className="director">{show?.director}</span>
                              </div>

                            </div>
                          </li>
                        ))}
                      </div>
                    ))}
                  </ul>
                  <div className="seeAll" onClick={() => searchSubmit(inputValue)}>
                    <button>
                      <Translate textKey={'see_all'} />
                    </button>
                  </div>
                </div>
              )}
            </div>
            {projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true" &&
             (
             
                  <div 
                  className={`languageDropdown ${isLanguageOpen ? "active" : ""}`}
                  onMouseOver={() => setIsLanguageOpen(true)}
                  onMouseLeave={() => setIsLanguageOpen(false)}
                >
                  
                  <div className="language">
                    <Translate textKey={'change_language'} /> ({selectedLanguageCode})
                  </div>
                  
                  {isLanguageOpen && (
                    <div className="languageOptions">
                      <div className="optionsList">
                        {languageOptions?.map((language) => (
                          <div
                            key={language?.language_id}
                            data-selected={language?.short_code === selectedLanguage?.short_code}
                            className="languageOption"
                            onClick={() => handleLanguageChange(language)}
                          >
                            ({language?.short_code}) {language?.language_name}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
            ) }
            <div className={menuHandler ? "userIcon" : "userIcon noActive"} onMouseEnter={() => setMenuHandler(true)} onClick={() => setMenuHandler(!menuHandler)}>
              <div className="imageContainer">
                <img
                  src={require("../../assets/Images/avatar.png")}
                  alt="Avatar"
                />
              </div>
              <div className="downArrow">
                <DownArrow />
              </div>
              <div className={menuHandler ? "menuListContainer" : "noActive menuListContainer"}>
                <div className="arrow">
                  <DownArrow />
                </div>
                <ul className="list">
                  {/* <li onClick={() => navigate("/privacy-policy")}>
                    <div className="icon">
                      <img
                        src={require("../../assets/Icons/privacy-policy.png")}
                        alt="Icon"
                      ></img>
                    </div>
                    <span>Privacy Policy</span>
                  </li>
                  <li onClick={() => navigate("/terms-and-conditions")}>
                    <div className="icon">
                      <img
                        src={require("../../assets/Icons/terms-and-conditions.png")}
                        alt="Icon"
                      ></img>
                    </div>
                    <span>Terms of Use</span>
                  </li>
                  <li onClick={() => navigate("/about-us")}>
                    <div className="icon">
                      <img
                        src={require("../../assets/Icons/info-button.png")}
                        alt="Icon"
                      ></img>
                    </div>
                    <span>About Us</span>
                  </li> */}
                  {user && (
                    <>
                      <Link to="/settings">
                        <li>
                          <div className="icon">
                            <img
                              src={require("../../assets/Icons/user.png")}
                              alt="Icon"
                            ></img>
                          </div>
                          <span><Translate textKey={'account'} /></span>
                        </li>
                      </Link>
                      <Link to="/tv">
                        <li>
                          <div className="icon">
                            <img
                              src={require("../../assets/Icons/television.png")}
                              alt="Icon"
                            ></img>
                          </div>
                          <span><Translate textKey={'link_tv_app'} /></span>
                        </li>
                      </Link>
                    </>
                  )}
                  <Link to="/contact-support">
                    <li>
                      <div className="icon">
                        <img
                          src={require("../../assets/Icons/contact.png")}
                          alt="Icon"
                        ></img>
                      </div>
                      <span><Translate textKey={'contact_support'} /></span>
                    </li>
                  </Link>
                  {/* {user && subscriptionLink && <Link to="/subscription">
                    <li>
                      <div className="icon">
                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 2H6v2h12V2zM4 6h16v2H4V6zm-2 4h20v12H2V10zm18 10v-8H4v8h16z" fill="#ffffff"></path> </g></svg>
                      </div>
                      <span><Translate textKey={'subscribe_now'}/></span>
                    </li>
                  </Link>} */}

                      {projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED ===
                      "true" &&
                      (projectInfo?.projectConfig?.config
                        ?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" &&
                        !isSubscribedUser ? (
                        <Link to="/checkout">
                          <li>
                            <div className="icon">
                              <img
                                src={require("../../assets/Icons/subscribe.png")}
                                alt="Icon"
                              ></img>
                            </div>
                            <span>
                              <Translate
                                textKey={
                                  projectInfo?.projectConfig?.config
                                    ?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT || 'subscribe'
                                }
                              />
                            </span>
                          </li>
                        </Link>
                      ) : (
                        !isSubscribedUser && projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true" &&(
                          <Link to="/subscription">
                            <li>
                              <span>
                                {" "}
                                <Translate textKey={"subscription_plans"} />{" "}
                              </span>
                            </li>
                          </Link>
                        )
                      ))}

                  {user ? (
                    <li className="logOut" onClick={() => logoutHandler()}>
                      <span><Translate textKey={'sign_out_of_appname'} /></span>
                    </li>
                  ) : (
                    <li className="logIn" onClick={() => navigate("/login")}>
                      <span>
                        <Translate textKey={'log_in_to_appname'} /></span>
                    </li>
                  )
                  }
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className={browseHover ? "browseMore active" : "browseMore"}>
        <div className="overlay" onClick={() => setBrowseHover(null)}></div>

        <div className="browseMoreContainer">
          <div className="arrow">
            <DownArrow />
          </div>
          { mainMenuItems?.length ===0 &&
          menuItems?.map((item, index) => (
            <div className="left" key={index}>
              <h1 className="categoryName">{item?.key}</h1>
              <ul>
                {item?.items?.map((itemShow, keyIndex) => (
                  <li key={keyIndex}>
                    <Link
                      to={`/category/${itemShow?.value}?career=${itemShow?.key}`}
                      state={{ careers: itemShow?.key }}
                      onClick={() => { setBrowseHover(null); setBrowseMoreMediumDevice(false); }}
                    >
                      <span> {itemShow?.value}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="browseMoreResponsive">
        <div
          className={
            browseMoreMediumDevice ? "searchArea active" : "searchArea"
          }
        >
          <div className="inputContainer" 
              ref={searchRefSmallContainer}
              onClick={() => {
                setSearchActive(true);
                setTimeout(() => {
                  searchRefSmall?.current?.focus();
                }, 0);
              }}>
            <SearchIcon
              onClick={() => {
                // searchResultsShow();
                searchSubmitBrowseMore(inputValue);
                setTimeout(() => {
                  searchRefSmall?.current?.focus();
                }, 0);
              }}
            />

            <input
              ref={searchRefSmall}
              onClick={() => {
                setSearchActive(true);
                setTimeout(() => {
                  searchRefSmall?.current?.focus();
                }, 0);
              }}
              type="text"
              value={inputValue}
              placeholder={!searchActive && "Search"}
              onChange={(e) => {
                // searchHandleChange(e?.target?.value);
                setInputValue(e?.target?.value);
              }}
              onKeyDown={(e) =>
                e.key === "Enter" ? searchSubmitBrowseMore(inputValue) : ""
              }
            />
          </div>
          {IsSearchLoading && (
            <div className="searchLoading">
              <SmallLoading />
            </div>
          )}

          {!IsSearchLoading && searchResults?.length > 0 && inputValue && (
            <div className="closeIcon">
              <CloseIcon onClick={() => searchClose()} />
            </div>
          )}
          {searchResults?.length > 0 && inputValue && (
            <div
              className="searchSuggestionsContainerMedium"
              ref={searchSuggestionRef}
            >
              <h6 className="heading">
                <Translate textKey={'total'} /> <span className="count">{searchResults?.length}</span>
              </h6>
              <ul className="lists">
                {searchResults?.slice(0, 8)?.map((item, index) => (
                  <li
                    className="list"
                    key={index}
                    onClick={() => showClickHandler(item, true)}
                  >
                    <div className="left">
                      <div className="imageContainer">
                        {
                          imageUrlCheck(thumbnailOrientation === "PORTRAIT" ? item?.logo : item?.logo_thumb) === true ? (
                            <img
                              src={
                                thumbnailOrientation === "PORTRAIT"
                                  ? `${item?.logo}`
                                  : `${item?.logo_thumb}`
                              }
                              alt="Thumb"
                            />
                          ) : (

                            <img
                              src={
                                thumbnailOrientation === "PORTRAIT"
                                  ? `${process.env.REACT_APP_IMAGE_URL}${item?.logo}`
                                  : `${process.env.REACT_APP_IMAGE_URL}${item?.logo_thumb}`
                              }
                              alt="Thumb"
                            />
                          )
                        }
                      </div>
                    </div>

                    <div className="right">
                      <h1 className="title">{item?.show_name?.slice(0, 50)}{item?.show_name?.length > 50 && "..."}</h1>
                      <span className="director">{item?.director}</span>
                    </div>
                  </li>
                ))}
              </ul>
              <div
                className="seeAll"
                onClick={() => searchSubmitBrowseMore(inputValue)}
              >
                <button><Translate textKey={'see_all'} /></button>
              </div>
            </div>
          )}
        </div>
        <div
          className={browseMoreMediumDevice ? "container active" : "container"}
        >
          <div className="head large">
            { mainMenuItems?.length === 0 && (
              <div className="left">
                <h1><Translate textKey={'browse'} /></h1>
              </div>
            )}
            <div className="right">
              <CloseIcon onClick={() => setBrowseMoreMediumDevice(false)} />
            </div>
          </div>
          <ul className="nav">
          { mainMenuItems?.length === 0 && (
            <>
              <Link to="/home">
                <li onClick={() => setBrowseMoreMediumDevice(false)}><Translate textKey={'home'} /></li>
              </Link>
              {projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" ? (<Link to="/live-channels" >
                <li onClick={() => setBrowseMoreMediumDevice(false)} className="link"><Translate textKey={'live'} /></li>
              </Link>) : (projectInfo?.projectConfig?.config?.LIVE_REQUIRED === "true" && <Link to="/player" state={{ isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname }}>
                <li onClick={() => setBrowseMoreMediumDevice(false)} className="link"><Translate textKey={'live'} /></li>
              </Link>)}
            </>
          )}
            {
              user &&
              <>
                <Link to="/my-list">
                  <li onClick={() => setBrowseMoreMediumDevice(false)}><Translate textKey={'my_list'} /></li>
                </Link>
                <Link to="/tv">
                  <li onClick={() => setBrowseMoreMediumDevice(false)}><Translate textKey={'link_tv_app'} /></li>
                </Link>
              </>
            }
            {subscriptionLink && projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && <Link to="/checkout">
              <li className="link" onClick={() => setBrowseMoreMediumDevice(false)}><Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT || 'subscribe'} /></li>
            </Link>}
          </ul>
          { mainMenuItems?.length !== 0 ? (
              mainMenuItems?.map((menu, index) => (
                <div className="top" key={index}>
                  {menu?.type === "MENU" && (
                    <>
                      <h1 className="categoryName">{menu?.value}</h1>
                      <ul className="nestedMenu">
                        {menu?.items?.map((subItem, subIndex) => {
                          if (subItem?.type === "MENU") {
                            return (
                              <li key={subIndex}>
                                <h1 className="categoryName">{subItem?.value}</h1>
                                <ul>{renderMenuItems(subItem?.items)}</ul>
                              </li>
                            );
                          } else if (subItem?.type === "LINK") {
                            return (
                              <li
                                key={subIndex}
                                className="link"
                                onClick={() => {
                                  if (subItem?.seo_url) {
                                    if(subItem.seo_url === "live") {
                                      const state = { isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname };
                                      localStorage.setItem("liveState", JSON.stringify(state));
                                      navigate(subItem?.seo_url, { state })
                                    }
                                    if (subItem.seo_url.startsWith('category/')) {
                                      const val = subItem.seo_url.substring(subItem.seo_url.lastIndexOf('/') + 1);
                                      navigate(`/${subItem.seo_url}?career=${val}`, {
                                        state: { careers: val },
                                      });
                                    } else {
                                      navigate(`/${subItem.seo_url}`);
                                    }
                                  } else if (subItem?.link) {
                                    window.open(subItem?.link, "_blank");
                                  }
                                }}
                              >
                                <span>{subItem?.value}</span>
                              </li>
                            );
                          }
                          return null;
                        })}
                      </ul>
                    </>
                  )}
                  {menu?.type === "LINK" && (
                    <li
                      className="straightLink"
                      onClick={() => {
                        setBrowseMoreMediumDevice(false);
                        if (menu?.seo_url) {
                          if(menu.seo_url === "live") {
                            const state = { isLive: true, prevLocation: location?.search ? location?.pathname + location?.search : location?.pathname };
                            localStorage.setItem("liveState", JSON.stringify(state));
                            navigate(menu?.seo_url, { state })
                          }
                          if (menu.seo_url.startsWith('category/')) {
                            const val = menu.seo_url.substring(menu.seo_url.lastIndexOf('/') + 1);
                            navigate(`/${menu.seo_url}?career=${val}`, {
                              state: { careers: val },
                            });
                          } else {
                            navigate(`/${menu.seo_url}`);
                          }
                        } else if (menu?.link) {
                          window.open(menu?.link, "_blank");
                        }
                      }}
                    >
                      <span>{menu?.value}</span>
                    </li>
                  )}
                </div>
              ))
          ) : (
            <>
            {projectInfo?.projectConfig?.config?.SHORTS_REQUIRED === "true" && user &&
              <div className="top">
                <h1 className="categoryName"><Translate textKey={'shorts'} /></h1>
                <ul>
                  <li onClick={() => { navigate("/shorts"); setBrowseMoreMediumDevice(false) }}><span><Translate textKey={'shorts'} /></span></li>
                </ul>
              </div>
            }
            {menuItems?.map((item, index) => (
              <div className="top" key={index}>
                <h1 className="categoryName">{item?.key}</h1>
                <ul>
                  {item?.items?.map((items, i) => (
                    <li key={i}>
                      <Link
                        to={`/category/${items?.value}?career=${items?.key}`}
                        state={{ careers: items?.key }}
                        onClick={() => setBrowseMoreMediumDevice(false)}
                      >
                        <span> {items?.value}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            </>
          )}
          {projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true" && (
                  <div 
                  className={`languageDropdown ${isLanguageOpen ? "active" : ""}`}
                  onClick={handleLanguageClick}
                >
                  <h1 className="language">
                    <Translate textKey={'change_language'} /> ({selectedLanguageCode})
                  </h1>
                  
                  {isLanguageOpen && (
                    <div className="languageOptions">
                      <div className="optionsList">
                        {languageOptions?.map((language) => (
                          <div
                            key={language?.language_id}
                            data-selected={language?.short_code === selectedLanguage?.short_code}
                            className="languageOption"
                            onClick={() => handleLanguageChange(language)}
                          >
                            ({language?.short_code}) {language?.language_name}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
            ) }
        </div>
      </div>
    </>
  );
};

export default Header;
